import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { ChatPannel, DrawingGuard, MapBoard, PropertyPanel, PropertySearchAutoComplete, ToolBar } from '_app/components';
import { OpenHousesModal, PropertyInfoModal, RecentActivitiesModal } from '_app/components/modals';
import { useMapSearchController } from '_app/features/property-search/useMapSearchController';

const MapSearch = () => {
  const params = useParams();
  const controller = useMapSearchController(params.tab);

  return (
    <div className="flex flex-1 flex-col justify-center items-center font-primary relative overflow-hidden">
      <ToolBar
        visibleSearch={false}
        visibleList={controller.toggleList}
        publicId={controller.publicId}
        isMapDrawing={controller.isMapDrawing}
        total={controller.total}
        items={controller.items}
        filterTab={controller.currentTab}
        tabCounts={controller.tabCounts}
        user={controller.user}
        onToggleList={controller.onToggleList}
        onToggleDrawing={controller.onToggleDrawing}
        onOpenHouses={controller.openHouses.onOpen}
        onToggleActivity={controller.activities.onOpen}
      />
      <div className="flex-1 w-full flex h-full flex-row relative">
        <div className={`flex-col z-30 relative border-r ${!controller.toggleList ? 'w-1/3 hidden md:flex' : 'absolute inset-0 h-full w-full'}`}>
          <PropertySearchAutoComplete onSelectAddress={controller.onAddProperty} searchAddresses={controller.onSearchManualAdd} />
          <PropertyPanel
            publicId={controller.publicId}
            currentTab={controller.currentTab}
            preSelected={controller.preSelected}
            items={controller.items}
            loading={controller.loading}
            loadingMore={controller.loadingMore}
            mapReady={controller.mapReady}
            toggleList={controller.toggleList}
            tabCounts={controller.tabCounts}
            success={controller.success}
            onClickItem={controller.onOpenPreview}
            onPreSelectItem={controller.onPreSelectItem}
            onLoadMore={controller.onLoadMore}
            onLike={controller.propertyActions.onLike}
            onDisLike={controller.propertyActions.onDisLike}
          />
          <DrawingGuard active={controller.isMapDrawing} />
        </div>
        <MapBoard
          items={controller.items}
          preSelected={controller.preSelected}
          mapCenter={controller.mapCenter}
          mapZoom={controller.mapZoom}
          isMapDrawing={controller.isMapDrawing}
          bounds={controller.bounds}
          mapReady={controller.mapReady}
          loading={controller.loading}
          success={controller.success}
          searchAsMove={controller.searchAsMove}
          toggleList={controller.toggleList}
          onMapReady={controller.onMapReady}
          onMapChange={controller.onMapChange}
          onMarkerClick={controller.onMarkerClick}
          onUpdateBounds={controller.onUpdateBounds}
          onToggleSearchAsMove={controller.onToggleSearchAsMove}
          onZoomIn={controller.onMapZoomIn}
          onZoomOut={controller.onMapZoomOut}
          onClear={controller.onClearMap}
          onSearchCurrentBounds={controller.onRefreshProperties}
        />
      </div>
      {!controller.toggleList && !controller.preview.visible && <ChatPannel {...controller.chat} />}
      <PropertyInfoModal
        visible={controller.preview.visible}
        onClose={controller.preview.onClose}
        loading={controller.preview.loading}
        item={controller.preview.item}
        publicId={controller.publicId}
        user={controller.user}
        propertyActions={controller.propertyActions}
        chat={controller.chat}
      />
      <OpenHousesModal
        visible={controller.openHouses.visible}
        items={controller.openHouses.items}
        loading={controller.openHouses.loading}
        onOpenPreview={controller.onOpenPreview}
        onClose={controller.openHouses.onClose}
      />
      <RecentActivitiesModal
        visible={controller.activities.visible}
        items={controller.activities.items}
        loading={controller.activities.loading}
        onClose={controller.activities.onClose}
      />
    </div>
  );
};

export default MapSearch;
